import { render, staticRenderFns } from "./ProfileAdditionalInformation.vue?vue&type=template&id=5aae6718&scoped=true&"
import script from "./ProfileAdditionalInformation.vue?vue&type=script&lang=js&"
export * from "./ProfileAdditionalInformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aae6718",
  null
  
)

export default component.exports